import { HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AccountId, IAccountDetailsDto, IBalanceDto, IRequestRefundDto, IStatementDto, IWalletDto } from 'src/app/contracts/api.types';
import { Api } from 'src/app/core/common/api';
import { IApiOptions } from 'src/app/core/contracts';
import { toHttpParams } from 'src/app/core/helpers/utils';

@Injectable({ providedIn: 'root' })
export class WalletData {
  private api = inject(Api);

  private details = new BehaviorSubject<IWalletDto>({ walletBalance: 0, debitBalance: 0 } as IWalletDto);
  public get details$() {
    return this.details.asObservable();
  }

  public getDetails(forceUpdate?: boolean, options?: IApiOptions): Promise<IWalletDto> {
    return new Promise(resolve => {
      if (forceUpdate) {
        this.api
          .get<IWalletDto>('wallet/details', options)
          .pipe(
            catchError(err => {
              resolve(this.details.getValue());
              return throwError(() => err as unknown);
            })
          )
          .subscribe((details: IWalletDto) => {
            this.details.next(details);
            resolve(details);
          });
      } else {
        resolve(this.details.getValue());
      }
    });
  }
  public withdrawBalance(iBANImage: Blob): Observable<number> {
    const data = new FormData();
    if (iBANImage) {
      data.append('file', iBANImage);
    }
    return this.api.post(
      'wallet/withdraw-balance',
      data,
      // empty header is required for mvc 5 to populate
      // System.Web.HttpContext.Current.Request.Files
      { headers: new HttpHeaders({}) }
    );
  }
  public getAccountStatement(accountId: AccountId, fromDate: Date, endDate: Date): Observable<IAccountDetailsDto> {
    const options: IStatementDto = {
      accountId,
      fromDate,
      endDate,
    };
    return this.api.get('wallet/get-account-statement', { params: toHttpParams(options) });
  }
  public getAccountBalance(accountId: AccountId, fromDate: Date, endDate: Date): Observable<IBalanceDto> {
    const options: IStatementDto = {
      accountId,
      fromDate,
      endDate,
    };
    return this.api.get('wallet/get-account-balance', { params: toHttpParams(options) });
  }
  public getRefundrequests(): Observable<IRequestRefundDto[]> {
    return this.api.get('wallet/refund-requests');
  }
  public dispose() {
    this.details.next({ walletBalance: 0, debitBalance: 0 } as IWalletDto);
    return Promise.resolve();
  }
}
